import axios from 'axios'
import router from '@/router'
import store from '@/store'

function initInterceptors() {
  // Add a request interceptor
  axios.interceptors.request.use(
    (config) => {
      if (isAuthenticated()) {
        const user = getUser()
        config.headers['token'] = user.token
        config.headers['account_id'] = user.accountId
        config.headers['account_type'] = user.accountType
        config.headers['company_id'] = user.companyId
      } else {
        delete config.headers['token']
        delete config.headers['account_id']
        delete config.headers['account_type']
        delete config.headers['company_id']
      }

      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
      store.commit('Progress/increment')

      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  axios.interceptors.response.use(
    (response) => {
      store.commit('Progress/decrement')
      return response
    },
    (error) => {
      store.commit('Progress/decrement')
      // console.log('axios.response', {error} )
      if (error.response && error.response.status === 401) {
        deleteUser()
        router.push('/')
      }

      return Promise.reject(error)
    }
  )
}

function isAuthenticated() {
  const userString = window.sessionStorage.getItem('user')
  const user = JSON.parse(userString)

  if (user) {
    return !!user.token
  } else {
    return false
  }
}

function getUser() {
  const userString = window.sessionStorage.getItem('user')
  const user = JSON.parse(userString)

  return user || {}
}

function setUser(payload) {
  const user = {
    token: payload.headers.token,
    accountId: payload.headers.account_id,
    companyId: payload.data.data.company_id,
    accountType: payload.data.data.type,
    account: payload.data.data.account,
    email: payload.data.data.email,
    phone: payload.data.data.phone,
  }

  window.sessionStorage.setItem('user', JSON.stringify(user))
}

function deleteUser() {
  window.sessionStorage.removeItem('user')
}

export default {
  initInterceptors,
  setUser,
  getUser,
  isAuthenticated,
}
